import { Button, Select } from "antd";
import React, { useCallback, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Creators as StockItemActions } from "../../../store/ducks/stockItem";
import useStockItemContext from "../../../hooks/useStockItemContext";
import { ContainerSelectStockItem, CustomSelect } from "./styles";

function SelectStockItem({
  customSelect = false,
  placeholder = null,
  value,
  onDeselect,
  onChange,
  onCreated,
  disabled = false,
  allowClear = true,
  showSearch = true,
}) {
  const {
    groupSelected: { id: groupId },
    farmSelected: { id: farmId },
    translation,
  } = useSelector((state) => state.app);

  const {
    listDropDown,
    isLoadingDropDown,
    newStockItem,
    shouldRefreshListDropDown,
  } = useSelector((state) => state.stockItem);

  const dispatch = useDispatch();
  const awaitingCreate = useRef(false);
  const { handleOpenNewItem } = useStockItemContext();

  const getStockItemList = useCallback(() => {
    dispatch(StockItemActions.getDropdownStockItem(groupId, farmId));
  }, [dispatch, groupId, farmId]);

  const createNewStockItem = useCallback(() => {
    awaitingCreate.current = true;
    handleOpenNewItem();
  }, [handleOpenNewItem]);

  useEffect(() => {
    getStockItemList();
  }, [getStockItemList]);

  useEffect(() => {
    if (awaitingCreate.current && newStockItem?.id) {
      onChange(newStockItem.id);
      if (onCreated) onCreated(newStockItem);
      awaitingCreate.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldRefreshListDropDown]);

  const options = listDropDown.map((item) => (
    <Select.Option key={item.id} value={item.id}>
      {item.internalId}
    </Select.Option>
  ));

  const hasMatchingOption = listDropDown.some((item) => item.id === value);

  const selectProps = {
    loading: isLoadingDropDown,
    value: hasMatchingOption ? value : undefined,
    placeholder: placeholder
      ? placeholder
      : translation.defaultSelectPlaceholder,
    showSearch,
    optionFilterProp: "children",
    filterOption: (input, option) =>
      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
    allowClear,
    disabled,
    onDeselect,
    onChange,
  };

  const SelectElement = customSelect ? (
    <CustomSelect {...selectProps}>{options}</CustomSelect>
  ) : (
    <Select {...selectProps}>{options}</Select>
  );

  return (
    <ContainerSelectStockItem>
      {SelectElement}
      <Button
        shape="circle"
        icon="plus"
        disabled={disabled}
        onClick={createNewStockItem}
      />
    </ContainerSelectStockItem>
  );
}

export default SelectStockItem;
